/** Edit template modal — aligned with misc-admin-panel.html tpl-overlay */

/** Prototype CSS vars: --teal #0d6e8a, --action-blue #2563eb */
export const MESSAGE_TEMPLATE_MODAL_TEAL = '#0d6e8a';
export const MESSAGE_TEMPLATE_ACTION_BLUE = '#2563eb';
export const MESSAGE_TEMPLATE_ACTION_BLUE_HOVER = '#1d4ed8';

export const editDialogPaperSx = {
    maxWidth: 720,
    width: '100%',
    borderRadius: '12px',
    overflow: 'hidden',
};

export const editDialogHeaderSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.125,
    px: '18px',
    py: '14px',
    bgcolor: MESSAGE_TEMPLATE_MODAL_TEAL,
    color: '#fff',
};

export const editDialogHeaderIconSx = {
    width: 30,
    height: 30,
    borderRadius: '8px',
    bgcolor: 'rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export const editDialogBodySx = {
    px: '20px',
    py: '20px',
    maxHeight: '68vh',
    overflowY: 'auto',
};

export const editDialogFooterSx = {
    px: '20px',
    py: '15px',
    borderTop: '1px solid #e2e8f0',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 1,
};

export const sectionLabelSx = {
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#64748b',
    pb: '7px',
    borderBottom: '1px solid #e2e8f0',
    mb: '11px',
};

export const sectionSx = {
    mb: '18px',
};

export const fieldLabelSx = {
    display: 'block',
    fontSize: 14,
    fontWeight: 500,
    color: '#334155',
    mb: 0.5,
};

export const fieldLabelMutedSx = {
    fontWeight: 400,
    color: '#94a3b8',
};

export const inputSx = {
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#e2e8f0',
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        fontSize: 14,
    },
    '& .MuiInputBase-input': {
        py: '10px',
        px: '12px',
    },
};

export const readOnlyInputSx = {
    ...inputSx,
    '& .MuiOutlinedInput-root': {
        ...inputSx['& .MuiOutlinedInput-root'],
        bgcolor: '#f9fafb',
    },
    '& .MuiInputBase-input': {
        ...inputSx['& .MuiInputBase-input'],
        color: '#64748b',
    },
};

export const varChipSx = {
    borderRadius: '99px',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    fontSize: 13,
    fontWeight: 400,
    height: 28,
    px: 1.25,
    border: '1px solid #cbd5e1',
    bgcolor: '#fff',
    color: '#64748b',
    cursor: 'pointer',
    textTransform: 'none',
    '&:hover': {
        borderColor: MESSAGE_TEMPLATE_ACTION_BLUE,
        color: MESSAGE_TEMPLATE_ACTION_BLUE,
        bgcolor: '#fff',
    },
};

export const bodyTextareaSx = {
    ...inputSx,
    '& .MuiInputBase-input': {
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
        fontSize: 13,
        lineHeight: 1.6,
    },
};

export const previewBoxSx = {
    fontSize: 13,
    lineHeight: 1.7,
    bgcolor: '#f9fafb',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    p: '11px 13px',
    maxHeight: 170,
    overflow: 'auto',
};

export const cancelButtonSx = {
    textTransform: 'none',
    borderColor: '#e2e8f0',
    color: '#64748b',
    px: 2.5,
};

export const saveButtonSx = {
    textTransform: 'none',
    fontSize: 15,
    fontWeight: 500,
    px: '15px',
    py: '9px',
    color: '#fff',
    bgcolor: MESSAGE_TEMPLATE_ACTION_BLUE,
    boxShadow: 'none',
    '&.MuiButton-contained': {
        bgcolor: MESSAGE_TEMPLATE_ACTION_BLUE,
        color: '#fff',
    },
    '&:hover': {
        bgcolor: MESSAGE_TEMPLATE_ACTION_BLUE_HOVER,
        boxShadow: 'none',
    },
    '&.MuiButton-contained:hover': {
        bgcolor: MESSAGE_TEMPLATE_ACTION_BLUE_HOVER,
    },
    '&.Mui-disabled': {
        color: '#fff',
        bgcolor: 'rgba(37, 99, 235, 0.45)',
    },
};
